import { RecordData } from '../../helpers-classes';
import { CountertopMaterialData, CountertopMaterialDataIn } from './types';

import { COUNTERTOP_DEFAULT_KEY, COUNTERTOP_DEFAULT_THICKNESS } from './constants';

export const countertopMaterialData = (dataIn: CountertopMaterialDataIn = null): CountertopMaterialData => {
	const rd = new RecordData<CountertopMaterialDataIn>(dataIn);

	const record: CountertopMaterialData = {
		key: rd.useNewOrDefault<string>('key', COUNTERTOP_DEFAULT_KEY),
		thickness: rd.useNewOrDefault<number>('thickness', COUNTERTOP_DEFAULT_THICKNESS),
		override: rd.useNewOrDefault<boolean>('override', false)
	};

	return record;
};
